import { Symbol, IPluginRegistry, MessengerModule, IPluginProvider } from '@map/core';
import { SpinnerService } from './SpinnerService';
import { ISpinnerService } from './ISpinnerService';

export module SpinnerModule {
  /**
   * The symbol for the Spinner Service to register on the PluginLocator.
   */
  export const serviceSymbol = new Symbol('SpinnerService');

  /**
   * Gets the IMessenger service from the given provider.
   *
   * @param provider The provider to use.
   */
  export const getService = (provider: IPluginProvider): ISpinnerService => {
    return provider.resolve<ISpinnerService>(serviceSymbol);
  };

  /**
   * Use the spinner module which gets the configuration from the native part.
   * @param registrar
   */
  export const use = (registrar: IPluginRegistry) => {
    MessengerModule.use(registrar);
    registrar.registerSingle(serviceSymbol, (p) => new SpinnerService(MessengerModule.getService(p)), MessengerModule.serviceSymbol);
  };
}
